import { call, put, select, takeLatest, take } from 'redux-saga/effects';
import { push } from 'connected-react-router';

import { userApi } from '../../../api';
import { isValidURL } from '../../../utils/other';

import { selectPathname, selectSearch } from '../../router/selectors';
import { selectPlan } from '../user/selectors';
import { updateQueryString } from '../../router/actions';
import { getInfo, GET_INFO_FULFILLED } from '../user/actions';
import { getFavorites } from '../../favorites/actions';
import { resetStore } from '../../resetStore/actions';

import * as actions from './actions';
import { selectSuccessRedirect } from './selectors';

function* onSuccessRedirect(url, validPlans) {
  try {
    yield take(GET_INFO_FULFILLED);
    const plan = yield select(selectPlan);

    if (validPlans.includes(plan)) {
      window.open(url, '_blank');
    }

    yield put(actions.resetSuccessRedirect());
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

function* login({ payload }) {
  const { redirectTo } = payload;
  try {
    yield put({ type: actions.LOGIN_PENDING });
    const { status } = yield call(userApi.login, payload);

    if (status !== 200) {
      return;
    }

    yield put({ type: actions.LOGIN_FULFILLED });
    yield put(updateQueryString({ modal: undefined }));
    yield put(getInfo());
    yield put(getFavorites());

    if (redirectTo) {
      yield take(GET_INFO_FULFILLED);
      yield put(push(redirectTo));

      return;
    }

    const { url, validPlans } = yield select(selectSuccessRedirect);

    if (isValidURL(url)) {
      yield onSuccessRedirect(url, validPlans);
    }
  } catch (e) {
    yield put({ type: actions.LOGIN_REJECTED, payload: e });
  }
}

function* logout() {
  try {
    yield put({ type: actions.LOGOUT_PENDING });
    const { status } = yield call(userApi.logout);

    if (status === 200) {
      yield put({ type: actions.LOGOUT_FULFILLED });

      const path = yield select(selectPathname);
      const search = yield select(selectSearch);
      const newPath = path.includes('settings') ? '/' : `${path}${search}`;

      yield put(push(newPath));

      yield put(resetStore());
    }
  } catch (e) {
    yield put({ type: actions.LOGOUT_REJECTED, payload: e });
  }
}

export function* watchLogin() {
  yield takeLatest(actions.LOGIN, login);
}

export function* watchLogout() {
  yield takeLatest(actions.LOGOUT, logout);
}
